// formReducer.js
const initialState = {
    token:'',
    refreshToken: '',
    tokenExpiresIn: '',
    refreshTokenExpiresIn: ''
};

const AdminPortalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_ADMIN_TOKEN':
            return {
                ...state,
                token: action.payload.token,
                refreshToken: action.payload.refreshToken,
                tokenExpiresIn: action.payload.tokenExpiresIn,
                refreshTokenExpiresIn: action.payload.refreshTokenExpiresIn,
            };
        case 'RESET' :
            return initialState;
        default:
            return state;
    }
};

export default AdminPortalReducer;